const mapFormBody = (body, restProps) => {
    return {
		documentId: body.documentID,
		documentName: body.documentName,
		documentTypeId: body.documentTypeID,
		engagementId: body.engagementID,
		headerId: body.formHeaderID,
		sectionId: body.formSectionID,
		...restProps
	};
};

export default (response, restProps) => response?.data?.[0]?.formBodies?.map(body => mapFormBody(body, restProps)) ?? [];
